var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var removingKeys = ['Backspace', 'Delete'];
var modifyLineText = function (text, idx, e, isCurrentLine) {
    var _a, _b, _c;
    // нахождение пробела
    var trailingSpaces = ((_a = text.match(/\s*$/)) === null || _a === void 0 ? void 0 : _a[0]) || '';
    // проверка значений типа '1. '
    var listIndexText = ((_b = text.match(/^\d+\.\s/)) === null || _b === void 0 ? void 0 : _b[0]) || null;
    // проверка значений типа '1.' (без пробела)
    text = text.trim();
    var cursorShift = 0;
    if (listIndexText !== "".concat(idx + 1, ". ") && listIndexText) {
        // Если номера не совпадают то добавляем новый номер.
        var newText = "".concat(idx + 1, ". ") + text.replace(listIndexText, '') + trailingSpaces;
        cursorShift = "".concat(idx + 1, ". ").length - listIndexText.length;
        return { modifiedLine: newText, cursorShift: cursorShift };
    }
    if (removingKeys.includes(e.key)) {
        if (listIndexText && (text === null || text === void 0 ? void 0 : text.length) === ((_c = listIndexText === null || listIndexText === void 0 ? void 0 : listIndexText.trim()) === null || _c === void 0 ? void 0 : _c.length)) {
            return { modifiedLine: '', cursorShift: -(listIndexText === null || listIndexText === void 0 ? void 0 : listIndexText.length) };
        }
        return { modifiedLine: text, cursorShift: cursorShift };
    }
    if (!listIndexText && text.length !== 0) {
        var newText = "".concat(idx + 1, ". ") + text + trailingSpaces;
        cursorShift = "".concat(idx + 1, ". ").length;
        return { modifiedLine: newText, cursorShift: cursorShift };
    }
    // вернем нормальный текст
    return { modifiedLine: text + trailingSpaces, cursorShift: cursorShift };
};
var saveCursorPosition = function (text, e) {
    var start = e.selectionStart;
    var end = e.selectionEnd;
    var currentLineIndex = -1;
    var currentLineStart = start;
    text.split('\n').forEach(function (lineText, idx) {
        if (currentLineIndex !== -1)
            return;
        var realLineText = ' ' + lineText;
        if ((realLineText === null || realLineText === void 0 ? void 0 : realLineText.length) > currentLineStart) {
            currentLineIndex = idx;
            return;
        }
        currentLineStart -= realLineText === null || realLineText === void 0 ? void 0 : realLineText.length;
    });
    return { start: start, end: end, currentLineIndex: currentLineIndex, currentLineStart: currentLineStart };
};
var shiftCursorPosition = function (cursorPosition, shift) {
    return __assign(__assign({}, cursorPosition), { start: (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.start) + shift, end: (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.end) + shift });
};
var restoreCursorPosition = function (textarea, _a) {
    var start = _a.start, end = _a.end;
    textarea.setSelectionRange(start, end);
};
var mapText = function (text, e, cursorPosition) {
    var newCursorPosition = cursorPosition;
    var modifiedText = text
        .split('\n')
        .map(function (lineText, idx) {
        var _a = modifyLineText(lineText, idx, e), modifiedLine = _a.modifiedLine, cursorShift = _a.cursorShift;
        if (idx === (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.currentLineIndex))
            newCursorPosition = shiftCursorPosition(cursorPosition, cursorShift);
        return modifiedLine;
    })
        .join('\n');
    return { modifiedText: modifiedText, newCursorPosition: newCursorPosition };
};
export var modifyToListText = function (text, e) {
    var cursorPosition = saveCursorPosition(text, e.target);
    var _a = mapText(text, e, cursorPosition), modifiedText = _a.modifiedText, newCursorPosition = _a.newCursorPosition;
    e.target.value = modifiedText;
    restoreCursorPosition(e.target, newCursorPosition);
    return modifiedText;
};
//# sourceMappingURL=modifyToListText.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var removingKeys = ['Backspace', 'Delete'];
var modifyLineText = function (text, idx, e, isCurrentLine) {
    var _a, _b, _c;
    // нахождение пробела
    var trailingSpaces = ((_a = text.match(/\s*$/)) === null || _a === void 0 ? void 0 : _a[0]) || '';
    // проверка значений типа '1. '
    var listIndexText = ((_b = text.match(/^\d+\.\s/)) === null || _b === void 0 ? void 0 : _b[0]) || null;
    // проверка значений типа '1.' (без пробела)
    text = text.trim();
    var cursorShift = 0;
    if (listIndexText !== "".concat(idx + 1, ". ") && listIndexText) {
        // Если номера не совпадают то добавляем новый номер.
        var newText = "".concat(idx + 1, ". ") + text.replace(listIndexText, '') + trailingSpaces;
        cursorShift = "".concat(idx + 1, ". ").length - listIndexText.length;
        return { modifiedLine: newText, cursorShift: cursorShift };
    }
    if (removingKeys.includes(e.key)) {
        if (listIndexText && (text === null || text === void 0 ? void 0 : text.length) === ((_c = listIndexText === null || listIndexText === void 0 ? void 0 : listIndexText.trim()) === null || _c === void 0 ? void 0 : _c.length)) {
            return { modifiedLine: '', cursorShift: -(listIndexText === null || listIndexText === void 0 ? void 0 : listIndexText.length) };
        }
        return { modifiedLine: text, cursorShift: cursorShift };
    }
    if (!listIndexText && text.length !== 0) {
        var newText = "".concat(idx + 1, ". ") + text + trailingSpaces;
        cursorShift = "".concat(idx + 1, ". ").length;
        return { modifiedLine: newText, cursorShift: cursorShift };
    }
    // вернем нормальный текст
    return { modifiedLine: text + trailingSpaces, cursorShift: cursorShift };
};
var saveCursorPosition = function (text, e) {
    var start = e.selectionStart;
    var end = e.selectionEnd;
    var currentLineIndex = -1;
    var currentLineStart = start;
    text.split('\n').forEach(function (lineText, idx) {
        if (currentLineIndex !== -1)
            return;
        var realLineText = ' ' + lineText;
        if ((realLineText === null || realLineText === void 0 ? void 0 : realLineText.length) > currentLineStart) {
            currentLineIndex = idx;
            return;
        }
        currentLineStart -= realLineText === null || realLineText === void 0 ? void 0 : realLineText.length;
    });
    return { start: start, end: end, currentLineIndex: currentLineIndex, currentLineStart: currentLineStart };
};
var shiftCursorPosition = function (cursorPosition, shift) {
    return __assign(__assign({}, cursorPosition), { start: (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.start) + shift, end: (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.end) + shift });
};
var restoreCursorPosition = function (textarea, _a) {
    var start = _a.start, end = _a.end;
    textarea.setSelectionRange(start, end);
};
var mapText = function (text, e, cursorPosition) {
    var newCursorPosition = cursorPosition;
    var modifiedText = text
        .split('\n')
        .map(function (lineText, idx) {
        var _a = modifyLineText(lineText, idx, e), modifiedLine = _a.modifiedLine, cursorShift = _a.cursorShift;
        if (idx === (cursorPosition === null || cursorPosition === void 0 ? void 0 : cursorPosition.currentLineIndex))
            newCursorPosition = shiftCursorPosition(cursorPosition, cursorShift);
        return modifiedLine;
    })
        .join('\n');
    return { modifiedText: modifiedText, newCursorPosition: newCursorPosition };
};
export var modifyToListText = function (text, e) {
    var cursorPosition = saveCursorPosition(text, e.target);
    var _a = mapText(text, e, cursorPosition), modifiedText = _a.modifiedText, newCursorPosition = _a.newCursorPosition;
    e.target.value = modifiedText;
    restoreCursorPosition(e.target, newCursorPosition);
    return modifiedText;
};
//# sourceMappingURL=modifyToListText.js.map